.sessionDetailsCard {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #f9fafb;
	border: 0.61px solid #e2e2e2;
	padding: 0.75rem;
	padding-bottom: 0.125rem;
	border-radius: 10px;
	gap: 0.625rem;
	align-items: center;
	justify-content: flex-start;
	box-sizing: border-box;

	.sessionDetailsCardRow {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
		gap: 0.25rem;

		.sessionDetailsIconWrapper {
			display: flex;
			flex-direction: row;
			gap: 0.5rem;
			align-items: center;

			& > svg:first-child {
				color: #975ede;
			}

			& :global(.MuiTypography-root) {
				color: #9b9b9b;
				font-weight: 700;
				font-size: 0.875rem;
				line-height: 1.6;
			}
		}
	}
}

.capacityControlRow {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;
	align-items: center;
	padding-bottom: 0.5rem;

	.capacityButtonWrapper {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		gap: 0.25rem;
		background-color: #ffffff;
		border: 0.61px solid #e2e2e2;
		padding: 0.25rem;
		border-radius: 8px;
		box-sizing: border-box;
	}

	& :global(.MuiTypography-root) {
		color: #212121;
		font-weight: 700;
		font-size: 0.875rem;
		line-height: 1.6;
	}

	.capacityButton {
		border-radius: 6px;
		width: 24px;
		height: 24px;
		padding: 0.25rem;

		&.add {
			background-color: #f4f5fc;

			& svg {
				color: #42296e;
			}
		}
	}

	& .maxTestTakers:global(.MuiTypography-root) {
		color: #6b6b6b;
		font-weight: 500;
		font-size: 0.875rem;
		letter-spacing: -0.08px;
		line-height: 1.6;
		text-align: center;
	}

	.capacityTextField {
		height: 100%;

		& :global(.MuiOutlinedInput-root) {
			height: 25px;
		}

		& :global(.MuiOutlinedInput-notchedOutline) {
			border: none;
		}

		& :global(.MuiInputBase-input) {
			text-align: center;
		}
	}
}

.minNoticeBadge:global(.MuiChip-root) {
	height: 26px;
	min-width: 120px;
	border-radius: 30px;
}

.dropdownItem:global(.Mui-disabled) .minNoticeBadge {
	color: #a6a6a6;
	background: #e6e6e6;
}

.dropdownItem {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
}

.sessionDetailsContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.75rem;

	.sessionDetailsGrid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 50%));
		column-gap: 1.25rem;
		row-gap: 1.25rem;
		width: 100%;
	}
}

.timeDetailsCard {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	grid-column: 1 / -1;
	width: 100%;
	background: #f9fafb;
	border: 0.61px solid #e2e2e2;
	border-radius: 10px;
	padding: 0.75rem;
	box-sizing: border-box;
}

.timePickerRow {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
}

.timePickerRow > label > div {
	width: 100%;
}

.timePickerButton:global(.MuiButton-root) {
	width: 100% !important;
	height: 48px !important;
	border-radius: 8px !important;
	padding: 0 0.75rem !important;
	font-size: 0.875rem !important;
	font-weight: 400 !important;
	color: #1f2937 !important;
	border-color: #d1d5db !important;
	text-align: left !important;
}

.timePickerButton:global(.MuiButton-root) :global(.MuiButton-endIcon) {
	margin-left: 4px;
}

.timePickerButton:global(.MuiButton-root) :global(.MuiButton-endIcon) > div {
	background: transparent;
	padding: 0;
}

.timePickerButton:global(.MuiButton-root) :global(.MuiButton-endIcon) svg {
	color: #111827 !important;
	width: 24px;
	height: 24px;
}

.timePickerButton:global(.MuiButton-root):hover {
	background-color: #ffffff !important;
}

.timeArrow {
	flex: 0 0 auto;
	width: 18px;
	height: 18px;
	color: lightgray;
	margin-top: 28px;
}

.timeFooterRow {
	display: grid;
	grid-template-columns: 1.8fr 1fr;
	gap: 0.5rem;
	width: 100%;
}

.validationOk,
.validationError,
.totalDuration {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	min-width: 0;
}

.validationOk :global(.MuiTypography-root),
.validationError :global(.MuiTypography-root) {
	color: #5b6573;
	font-size: 0.75rem;
	font-weight: 500;
	line-height: 1.4;
}

.validationOk svg {
	width: 14px;
	height: 14px;
	color: #22c55e;
	flex: 0 0 auto;
}

.validationError svg {
	width: 14px;
	height: 14px;
	color: #c2410c;
	flex: 0 0 auto;
}

.totalDuration {
	margin-left: auto;
}

.totalDuration svg {
	width: 16px;
	height: 16px;
	color: #975ede;
	flex: 0 0 auto;
}

.totalDuration :global(.MuiTypography-root) {
	color: #212121;
	font-size: 0.875rem;
	font-weight: 500;
	line-height: 1.4;
}

.durationBadge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 54px;
	height: 32px;
	padding: 0 0.5rem;
	border-radius: 8px;
	background: #f1e5ff;
	color: #6d28d9;
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1;
	box-sizing: border-box;
}

.fixedProctor:global(.MuiTypography-root) {
	color: #0a0a0a;
	font-weight: 400;
	font-size: 0.875rem;
	line-height: 1.6;
	letter-spacing: -0.15px;
}

.proctorContainer {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
}

.proctorErrorRow {
	width: 100%;
}

@media (max-width: 768px) {
	.sessionDetailsCard {
		padding-bottom: 0.5rem;
	}
	.sessionDetailsContainer {
		.sessionDetailsGrid {
			grid-template-columns: minmax(0, 1fr);
		}
	}

	.capacityControlRow {
		flex-direction: column;
	}
}
